function homepage() {
	const mainHomepage = document.querySelector('main.homepage');
	if (!mainHomepage) return;

	gsap.to('.hero-image-planet-1', {
		y: 600,
		ease: "power1.inOut",
		scrollTrigger: {
			trigger: '.hero',
			start: "top top",
			end: "bottom top",
			scrub: true,
		}
	});

	gsap.to('.hero-image-planet-2', {
		x: 200,
		y: -200,
		ease: "power1.inOut",
		scrollTrigger: {
			trigger: '.hero',
			start: "top top",
			end: "bottom top",
			scrub: true,
		}
	});

	gsap.to('.hero-image-planet-3', {
		y: -600,
		ease: "power1.inOut",
		scrollTrigger: {
			trigger: '.hero',
			start: "top top",
			end: "bottom top",
			scrub: true,
		}
	});

	gsap.to('.hero-image-planet-4', {
		x: -300,
		y: 300,
		ease: "power1.inOut",
		scrollTrigger: {
			trigger: '.hero',
			start: "top top",
			end: "bottom top",
			scrub: true,
		}
	});

	gsap.to('.hero-image-planet-5', {
		y: -400,
		ease: "power1.inOut",
		scrollTrigger: {
			trigger: '.hero',
			start: "top top",
			end: "bottom top",
			scrub: true,
		}
	});
}
